import { UseToastOptions } from "@chakra-ui/react";
import { Override } from "@syla/shared/types/helpers/Override";
import {
  getWalletName,
  PopulatedWallet,
} from "@syla/shared/types/models/WalletBase";
import { secondsToMilliseconds } from "date-fns";

export function buildSyncSuccessToastProps(
  wallets: Pick<
    Override<PopulatedWallet, { dataSource: { name: string } }>,
    "customName" | "dataSource"
  >[],
): UseToastOptions {
  return {
    status: "success",
    title: `${
      wallets.length == 1 ?
        getWalletName({
          wallet: wallets[0],
          dataSource: wallets[0].dataSource,
        })
      : "Data Sources"
    } synced successfully`,
    duration: secondsToMilliseconds(5),
    isClosable: true,
  };
}
